export default __webpack_public_path__ + "static/media/OSMOS_CALCE_120X120_mobile.bab065e3.jpg";